export const CONFIG_FIELD_NORMAL_EVENT_RANGE = '1';
export const CONFIG_FIELD_LONG_EVENT_RANGE = '2';
export const CONFIG_FIELD_DEFAULT_CAPACITY = '3';
export const CONFIG_FIELD_DEFAULT_TIME = '4';
export const CONFIG_FIELD_LAST_AGREEMENT = '5';
export const COUPON_VAL_TYPE_NONE = '0';
export const COUPON_VAL_TYPE_DOLLAR = '1';
export const COUPON_VAL_TYPE_PERCENT = '2';
export const DUES_PAYMENT_METHOD_NONE = '0';
export const DUES_PAYMENT_METHOD_CASH = '1';
export const DUES_PAYMENT_METHOD_CHECK = '2';
export const DUES_PAYMENT_METHOD_CREDIT = '3';
export const DUES_PAYMENT_METHOD_COUPON = '4';
export const DUES_PAYMENT_METHOD_SPLIT = '5';
export const DUES_PAYMENT_METHOD_BARTER = '6';
export const DUES_PAYMENT_METHOD_OTHER = '7';
export const DUES_PAYMENT_METHOD_EXTENSION = '8';
export const ENTITY_TYPE_NONE = '0';
export const ENTITY_TYPE_PERSON = '1';
export const ENTITY_TYPE_MEMBERSHIP = '2';
export const ENTITY_TYPE_ORGANIZATION = '3';
export const ENTITY_TYPE_EVENT = '4';
export const ENTITY_TYPE_RESERVATION = '5';
export const ENTITY_TYPE_APPLICATION = '6';
export const EVENT_RANGE_SHORT = '1';
export const EVENT_RANGE_LONG = '2';
export const GENDER_NONE = '0';
export const GENDER_MALE = '1';
export const GENDER_FEMALE = '2';
export const GENDER_OTHER = '3';
export const MEMBERSHIP_LEVEL_NONE = '0';
export const MEMBERSHIP_LEVEL_BASIC = '1';
export const MEMBERSHIP_LEVEL_PREMIUM = '2';
export const MEMBERSHIP_LEVEL_VIP = '3';
export const MEMBERSHIP_LEVEL_UNLIMITED = '4';
export const MEMBERSHIP_STATUS_NONE = '0';
export const MEMBERSHIP_STATUS_NEW = '1';
export const MEMBERSHIP_STATUS_ACTIVE = '2';
export const MEMBERSHIP_STATUS_LOCKED = '3';
export const MEMBERSHIP_STATUS_INACTIVE = '4';
export const MEMBERSHIP_STATUS_TERMINATED = '5';
export const MEMBERSHIP_TYPE_NONE = '0';
export const MEMBERSHIP_TYPE_COUPLE = '1';
export const MEMBERSHIP_TYPE_FEMALE = '2';
export const MEMBERSHIP_TYPE_MALE = '3';
export const PERSON_STATUS_NONE = '0';
export const PERSON_STATUS_PENDING = '1';
export const PERSON_STATUS_APPROVED = '2';
export const PERSON_STATUS_REJECTED = '3';
export const PERSON_STATUS_TERMINATED = '4';
export const PERSON_STATUS_INACTIVE = '5';
export const PERSON_STATUS_SUSPENDED = '6';
export const PERSON_STATUS_WAITLIST = '7';
export const RESERVATION_PAYMENT_METHOD_NONE = '0';
export const RESERVATION_PAYMENT_METHOD_CASH = '1';
export const RESERVATION_PAYMENT_METHOD_CHECK = '2';
export const RESERVATION_PAYMENT_METHOD_CREDIT = '3';
export const RESERVATION_PAYMENT_METHOD_COUPON = '4';
export const RESERVATION_PAYMENT_METHOD_SPLIT = '5';
export const RESERVATION_PAYMENT_METHOD_BARTER = '6';
export const RESERVATION_PAYMENT_METHOD_OTHER = '7';
export const RESERVATION_STATUS_NONE = '0';
export const RESERVATION_STATUS_PENDING = '1';
export const RESERVATION_STATUS_CONFIRMED = '2';
export const RESERVATION_STATUS_ARRIVED = '3';
export const RESERVATION_STATUS_CANCELED = '4';
export const RESERVATION_STATUS_NO_SPACE = '5';
export const RESERVATION_STATUS_NO_SHOW = '6';
export const RESERVATION_STATUS_PREPAID = '7';
export const RESERVATION_TYPE_NONE = '0';
export const RESERVATION_TYPE_COUPLE = '1';
export const RESERVATION_TYPE_FEMALE = '2';
export const RESERVATION_TYPE_MALE = '3';


export const GUEST_OP_NONE = '0';
export const GUEST_OP_NEW = '1';
export const GUEST_OP_UPDATE = '2';
export const GUEST_OP_DELETE = '3';

export const ORG_ID_CHOICE = '1';
export const ORG_ID_FETISH = '2';
export const ORG_ID_ANY = '3';


